import { Component, OnInit } from '@angular/core';
import { Subscription, fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { NetworkConectionService } from '../../services/network/networkConection.service';

@Component({
  selector: 'app-internet-status',
  templateUrl: './internet-status.component.html',
  styleUrls: ['./internet-status.component.css']
})
export class InternetStatusComponent implements OnInit {

  public netStatus: boolean = true;

  private connectionSubscription: Subscription = new Subscription;
  constructor(private networkConectionService: NetworkConectionService) { }

  // Implementar ngOnInit para inicializar correctamente
  ngOnInit() {
    this.netStatus = true;
  }

  enableInternetStatus() {
    this.connectionSubscription = this.networkConectionService
      .checkInternetConnection()
      .subscribe((isOnline) => {
        this.netStatus = isOnline;
      });
  }

  disableInternetStatus() {
    this.networkConectionService.stopConnectionCheck();
    this.connectionSubscription.unsubscribe();
  }

  // Agregar ngOnDestroy para limpiar la suscripción
  ngOnDestroy() {
    if (this.connectionSubscription) {
      this.connectionSubscription.unsubscribe();
    }
  }
}
